module.exports = __webpack_public_path__ + "media/images/icons/icon-pause-1568a7b427b95bba862f6eeabeda2745.svg";